import type { Product } from '../types';

/**
 * The matrix is a blank/apparel stock surface: colour rows by size columns.
 * Pre-printed design SKUs are finished units and belong in the list view,
 * where their full SKU and design identity remain visible. Including them in
 * the matrix creates a misleading one-off "Pre-printed" pseudo-category.
 */
export const isInventoryMatrixProduct = (product: Product): boolean =>
  Boolean(product.category.size) && !product.isPreprinted;
